export interface Price {
    currencyCode?: string;
    priceValue: number;
    sortIndex?: number;
}

export function isPrice(price: Price | string | number): price is Price {
    return (price as Price).priceValue !== undefined;
}
